import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

// assets
import successImage from 'assets/images/success-image.svg'
import { IFilteredGymSalonList } from 'types/GymType'
import DateUtil from 'utils/DateUtil'
import useGymSalonReservationModal from '../../hooks/use-gym-salon-reservation-modal'
import NotificationDialog from 'components/ui/NotificationDialog'
import GymPersonalCard from './GymPersonalCard'
import ReservationModalWrapper from './reservation-scheduler/ReservationModal'

interface ComponentProps {
  filteredDate: Date | undefined
  renderList: IFilteredGymSalonList[]
  showCapacity: boolean
  runAfterSubmit: () => void
}

/* filtered date - default */
const defaultDate = DateUtil.getStartOfDay(new Date())

export default function GymPersonalCardContainer({
  filteredDate,
  renderList,
  showCapacity,
  runAfterSubmit,
}: ComponentProps) {
  const history = useHistory()
  const { t } = useTranslation()
  const _filteredDate = filteredDate || defaultDate

  /* Reservation Modal (Open - Close, Selected Gym Salon). | Custom Hook */
  const {
    openModal,
    closeModal,
    modal: isOpen,
    selectedSalon,
    notification,
    setNotification,
  } = useGymSalonReservationModal<IFilteredGymSalonList>()

  const closeNotification = () => {
    runAfterSubmit()
    setNotification(false)
  }

  return (
    <>
      {renderList?.map((salon) => (
        <GymPersonalCard key={salon.id} showCapacity={showCapacity} salon={salon} openModal={openModal} />
      ))}

      {/* Gym Salon Reservation Scheduler Modal */}
      {!!selectedSalon ? (
        <ReservationModalWrapper
          open={isOpen}
          openModal={openModal}
          closeModal={closeModal}
          showNotification={() => {
            runAfterSubmit()
            setNotification(true)
          }}
          selectedSalon={selectedSalon}
          filterDate={_filteredDate}
        />
      ) : null}

      <NotificationDialog
        display={notification}
        imgSrc={successImage}
        goHomeButton={true}
        title={t('gym-res-modal.notification-title')}
        content={t('gym-res-modal.notification-text')}
        firstButtonLabel={t('buttons.go-to-calendar')}
        onHide={closeNotification}
        onSubmit={() => history.push('/calendar')}
        selectedType={null}
        setSelectedType={undefined}
        types={[]}
      />
    </>
  )
}
